export default __webpack_public_path__ + "static/media/pv-3.4ec7197a.png";